
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { FileCheck } from 'lucide-react';

interface FilePreviewProps {
  file: File;
}

export const FilePreview = ({ file }: FilePreviewProps) => {
  return (
    <Alert>
      <FileCheck className="h-4 w-4" />
      <AlertTitle>File selected</AlertTitle>
      <AlertDescription>
        {file.name} ({Math.round(file.size / 1024)} KB)
      </AlertDescription>
    </Alert>
  );
};
